export default {
  isXS: () => window.matchMedia("(max-width: 639px)").matches,
  isSM: () => window.matchMedia("(min-width: 640px) and (max-width: 767px)").matches,
  isMD: () => window.matchMedia("(min-width: 768px) and (max-width: 1023px)").matches,
  isLG: () => window.matchMedia("(min-width: 1024px)").matches,
}